export default __webpack_public_path__ + "static/favicon-48x48-5cb692ae2be051f0df2e1f6ef7f0ce5c.png";